import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

export const HeroFloatingJobCard = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.6 }}
    className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-2xl p-5 w-64"
    data-testid="hero-floating-job-card"
  >
    <div className="flex items-center gap-2 text-xs font-bold text-rr-red mb-2">
      <span className="w-2 h-2 rounded-full bg-rr-red" /> RELIEF NEEDED
    </div>
    <div className="flex items-center gap-1 text-rr-navy font-heading font-bold">
      <MapPin size={15} className="text-rr-orange" /> Orlando, FL → Atlanta
    </div>
    <div className="mt-2 text-xs text-rr-muted">441 mi • Dry Van</div>
    <div className="mt-3 text-xs font-bold text-rr-green flex items-center gap-1">✓ FUNDS SECURED</div>
  </motion.div>
);
